import * as React from 'react';

import { MIN_NEWBUILDINGS_FOR_COMPARE_ZHK, UXFB_EVENT_COMPARE_ZHK } from '../../constants/uxfb';
import { sendUXSEventWhenReady } from '../../utils/uxs';

export type TUxfbPlatform = 'desktop' | 'mobweb';

/**
 * Шлёт UXFB-событие `compare_zhk` один раз за заход на страницу сравнения ЖК.
 * `newbuildingsCount` — сколько ЖК в таблице: по спеке событие нужно только при 2 и более,
 * с одним ЖК (или пока данных нет) не шлём.
 */
export function useCompareZhkUxfbEvent(platform: TUxfbPlatform, newbuildingsCount: number): void {
  const hasSentRef = React.useRef(false);
  const enabled = newbuildingsCount >= MIN_NEWBUILDINGS_FOR_COMPARE_ZHK;

  React.useEffect(() => {
    if (!enabled || hasSentRef.current) {
      return;
    }

    hasSentRef.current = true;
    sendUXSEventWhenReady(UXFB_EVENT_COMPARE_ZHK, { platform });
  }, [platform, enabled]);
}
